import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError, getCookie } from '../../utils'


export const identificationTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'IDENTIFIATION');
export const identificationUpdateTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'IDENTIFIATION_UPDATE');
export const tinUpdateTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'TIN_UPDATE');


export const requestIdentification = (id) => {
    return {
        type: identificationTypes.REQUEST,
        id: id,
    };
};

export const receiveIdentification = (response, id) => {
    return {
        type: identificationTypes.RECEIVE,
        data: response,
        id: id,
    };
};

export const receiveIdentificationError = (response, id) => {
    return {
        type: identificationTypes.ERROR,
        error: response,
        id: id,
    };
};

export const fetchIdentification = (id) => {
    return dispatch => {
        let apiUrl = `/api/v1/customer/${id}/identification`

        dispatch(requestIdentification(id));

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveIdentification(response, id));
            } catch (e) {
                dispatch(receiveIdentificationError(response, id));
            }
        })
        .catch(handleNetworkError);
    };
};


export const requestIdentificationUpdate = () => {
    return {
        type: identificationUpdateTypes.REQUEST,
    };
};

export const receiveIdentificationUpdate = (response) => {
    return {
        type: identificationUpdateTypes.RECEIVE,
        data: response,
    };
};

export const receiveIdentificationUpdateError = (response) => {
    return {
        type: identificationUpdateTypes.ERROR,
        error: response,
    };
};


export const updateContractIdentification = (uuid, data) => {
    return dispatch => {
      let apiUrl = `/api/v1/contract/${uuid}/identification/`
  
      dispatch(requestIdentificationUpdate());
  
      let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCookie("csrftoken"),
      }
  
      return fetch(apiUrl, {
        method: 'PATCH',
        headers: headers,
        body: JSON.stringify(data),
      })
      .then(parseJSON)
      .then(response => {
        try {
          dispatch(receiveIdentificationUpdate(response));
        } catch (e) {
          dispatch(receiveIdentificationUpdateError(response));
        }
      })
      .catch(handleNetworkError);
    };
  };
